import { arrConcat } from '../fun-js-lib/arr'
import { htmlOnInput } from '../fun-js-lib/html'
import { contentHint } from './hint'
import { isRemarksFilledIncorrectly } from './remarks'
import { getShiftTimesEditableInputs, isShiftTimesFilledIncorrectly } from './shiftTimes'
import { isEditedBySupervisor } from './signValidation'
import { getTemperatureInputs, isTemperatureFieldsFilledIncorrectly } from './temperature'
import { getWeatherInputs, isWeatherFieldsFilledIncorrectly } from './weather'
import { isWorkDescriptionFilledIncorrectly } from './work-description'
import { getWorkDescriptionAndRemarksInputs } from './work-description-and-remarks'
import { getMechanizationTextarea, getWorkersEditableInputs, isMechanizationFilledIncorrectly, isNWorkerssFilledIncorrectly } from './workers-and-mechanization'

export const checkContentFilledCorrectly = () =>
  isContentFilledCorrectly() ?
    '' :
    contentHint

export const isContentFilledCorrectly = () =>
  isEditedBySupervisor() ?
    !isRemarksFilledIncorrectly() :
    isContractorContentFilledCorrectly()

/**
 * @param {() => any} f 
 */
export function onInputInContent (f) {
  getAllEditableInputs().forEach(input => {
    htmlOnInput(input, f)
  })
  if (!isEditedBySupervisor()) {
    htmlOnInput(getMechanizationTextarea(), f)
  }
}

function isContractorContentFilledCorrectly () {
  let hasIncorrectFields =
    isShiftTimesFilledIncorrectly() ||
    isNWorkerssFilledIncorrectly() ||
    isMechanizationFilledIncorrectly() ||
    isTemperatureFieldsFilledIncorrectly() ||
    isWeatherFieldsFilledIncorrectly() ||
    isWorkDescriptionFilledIncorrectly()
  return !hasIncorrectFields
}

function getAllEditableInputs () {
  return arrConcat([
    getShiftTimesEditableInputs(),
    getWorkersEditableInputs(),
    getTemperatureInputs(),
    getWeatherInputs(),
    getWorkDescriptionAndRemarksInputs()
  ]).filter(input =>
    !input.hasAttribute('disabled') &&
    !input.hasAttribute('readonly'))
}